import {
  APPLY_FILTERS,
  CLEAR_FILTERS,
  SET_ITEMS,
  RESET,
  SET_CLIENT,
  RESET_CLIENT_STATE
} from './types';

export const INIT_STATE = {
  filters: {
    phone: '',
    page: 1,
    pageSize: 20,
    sort: ['step_index', 'last_modify', 'id', 'order_staff', 'order_name'],
  },
  items: [],
  client: {},
  total: 0,
  countUnclaimed: 0,
  countPending: 0,
  countContact: 0,
  countQuoted: 0,
  countAppointment: 0,
};

const mutations = {
  [APPLY_FILTERS](state, filters) {
    state.filters = {
      ...state.filters,
      ...filters
    };
  },

  [CLEAR_FILTERS](state) {
    state.filters = { ...INIT_STATE.filters };
  },

  [SET_ITEMS](state, { items, total, countUnclaimed, countPending, countContact, countQuoted, countAppointment }) {
    state.items = [...items];
    state.total = total;
    state.countUnclaimed = countUnclaimed;
    state.countPending = countPending;
    state.countContact = countContact;
    state.countQuoted = countQuoted;
    state.countAppointment = countAppointment;
  },

  [SET_CLIENT](state, client) {
    state.client = client;
  },

  [RESET_CLIENT_STATE](state) {
    state.client = null;
  },

  [RESET](state) {
    Object.keys(INIT_STATE).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(INIT_STATE, key)) {
        state[key] = INIT_STATE[key];
      }
    });
  },

};

export default mutations;
